import Swal from "sweetalert2";
import { fetchConToken, fetchSinToken } from "../helpers/fetch"
import { types } from "../types/types";

export const startLogin = (email, password) => {
    return async (dispatch) => {//dispatch puedo usar gracias a thunk
        const usuario = {
            // usuario:email,
            // password
            usuarioEmail: email,
            usuarioPassword: password,
        }
        const resp = await fetchSinToken('back/auth/login', usuario, 'POST');
        const body = await resp.json();

        if (body.ok) {
            localStorage.setItem('token', body.token);
            localStorage.setItem('token-init-date', new Date().getTime());
            dispatch(login({
                // name: body.nombres,
                // usuario: body.usuario,
                // rolid: body.rolid,
                id: body.id,
                email: body.email,
                name: body.name,
                apellidos: body.apellidos
            }))
            return { ok: true };
        }
        else {
            Swal.fire('Error', body.message, 'error')
            return { ok: false, message: body.message }
        }
    }
}
export const startRegister = (data) => {
    return async () => {
        try {
            const resp = await fetchSinToken('back/auth/register', data, 'POST');
            const body = await resp.json();

            if (body.ok) {
                return { ok: true };
            } else {
                return { ok: false, msg: body.message || 'Error al registrarse' };
            }
        } catch (error) {
            return { ok: false, msg: 'Error del servidor' };
        }

    }
}

export const startEmailVerification = ({ email, codigo }) => {
    return async (dispatch) => {
        try {
            const resp = await fetchSinToken('back/auth/email-verification', {
                email,
                codigo
            }, 'POST');

            const body = await resp.json();

            if (body.token) {
                localStorage.setItem('token', body.token);
                localStorage.setItem('token-init-date', new Date().getTime());

                dispatch(login({
                    email: body.email,
                    name: body.name,
                    apellidos: body.apellidos
                }));

                return { ok: true };
            } else {
                Swal.fire('Error', 'Código inválido', 'error');
                return { ok: false };
            }
        } catch (error) {
            Swal.fire('Error', 'Error en la verificación del código', 'error');
            return { ok: false };
        }
    };
};


export const startChecking = () => {
    return async (dispatch) => {

        const resp = await fetchSinToken('back/auth/renew');
        const body = await resp.json();
        if (body.ok) {
            localStorage.setItem('token', body.token);
            localStorage.setItem('token-init-date', new Date().getTime());
            dispatch(login({
                email: body.email,
                name: body.name,
                apellidos: body.apellidos
            }))
        } else {
            //Swal.fire('Error',body.msg,'error')
            dispatch(checkingFinish());
            dispatch(logout());
        }
    }
}

const checkingFinish = () => ({
    type: types.authCheckingFinish
})

const login = (user) => ({
    type: types.authLogin,
    payload: user
})

export const startLogout = () => {
    return (dispatch) => {
        localStorage.clear();
        dispatch(logout());
    }

}
const logout = () => ({
    type: types.authLogout
})

export const loadUsers = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('auth/getUsers')
            const body = await resp.json();
            const registros = body.registro;
            if (body.ok) {
                dispatch(setUsersList(registros))
            }
        } catch (error) {
            console.log(error)
        }
    }
}

const setUsersList = (registros) => ({
    type: types.userList,
    payload: registros
})